import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=6b082650&"
import script from "./PromoCodes.vue?vue&type=script&lang=ts&"
export * from "./PromoCodes.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&id=6b082650&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports